import { ParseHelper } from './../../parse.helper';

import { CdkDragDrop, CdkDragStart, moveItemInArray } from "@angular/cdk/drag-drop";
import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Subject, takeUntil } from "rxjs";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { AccountModuleId, AccountModuleName, CaseModuleId, LeadModuleId, LeadModuleName, OpportunityModuleId } from "../../constants/modules.constant";
import { ColumnSettingsN, DefaultView, Fields, SectionN, UpdateColumnSettings, UpdateFields, UpdateSections } from "../../models/column-settings.model";
import { SharedColumnSettingsService } from "../../services/column-settings.service";


const DragConfig = {
    dragStartThreshold: 0,
    pointerDirectionChangeThreshold: 5,
    zIndex: 99999
};

@Component({
  selector: 'app-column-settings-modal-for-rules',
  templateUrl: './column-settings-modal-for-rules.component.html',
  styleUrls: ['./column-settings-modal-for-rules.component.scss']
})
export class ColumnSettingsModalForRulesComponent implements OnInit, OnChanges {

    @Input() displayColumnSettings: boolean = false;
    @Input() moduleName: string = '';
    @Input() selectedView: string = '';
    @Input() settingsObj: Partial<ColumnSettingsN> = {};
    @Input() channelId: number;
    @Input() maxColumn: number = 12;
    @Input() disabledLabelNames: string[] = [];
    @Input() mergeAccountSequenceNumber: boolean = false;
    @Output() cancelColumnSettings = new EventEmitter();
    @Output() savedColumnSettings = new EventEmitter();

    private ngUnsubscribe = new Subject<void>();

    tab;
    tab1: any;
    tab2: any;
    tab3: any;
    tab4: any;
    tab5: any;
    showDiv = {
        stepsbar: false,
        views: false,
        collists: false,
        config: false,
        details: false,
        kanban: false
    }
    listSearchInput: string = '';
    detailListSearchInput: string = '';

    maxCheckedFieldForList: boolean = false;
    maxCheckedFieldForDetails: boolean = false;
    maxCheckedFieldForKanban: boolean = false;
    totalAmtForList: number = 0;
    totalAmtForDetails: number = 0;
    totalAmtForKanban: number = 0;

    availableDefaultView: DefaultView[] = [];
    tempColumnSettings: Partial<ColumnSettingsN> = {};
    tempDisplayStepBar: boolean = false;
    tempDisplayStepBarVM: boolean = false;
    tempView : Partial<DefaultView> = {};
    tempViewVM : Partial<DefaultView> = {};
    tempCols: SectionN[];
    tempDetailBlocks: SectionN[];
    tempKanbanDetailCols: SectionN[];
    tempColsVM: SectionN[];
    tempColsVM2: SectionN[];
    tempDetailBlocksVM: SectionN[];
    tempDetailBlocksVM2: SectionN[];
    tempKanbanDetailColsVM: SectionN[];
    tempKanbanDetailColsVM2: SectionN[];

    showConfigureEmailButton: boolean = false;
    isUserSignedIn: boolean = false;
    showContent: boolean = true;
    startDrag: boolean = false;

    updateColumnSettingsData: Partial<UpdateColumnSettings> = {};
    moduleId: number = 0;
    detectStepBarOrDefaultViewChange: boolean = false;
    defaultDisabledColumns: string[] = [];
    isSelectAllSectionField: boolean = false;

    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private zone: NgZone,
        private cdr: ChangeDetectorRef,
        public appMainService: AppMainService,
        private app: AppMainComponent,
        private sharedColumnSettingService: SharedColumnSettingsService
    ) {
        this.updateColumnSettingsData.listViewFields = [];
        this.updateColumnSettingsData.detailsViewFields = [];
        this.updateColumnSettingsData.kanbanViewFields = [];
        this.updateColumnSettingsData.listViewSections = [];
        this.updateColumnSettingsData.detailsViewSections = [];
        this.updateColumnSettingsData.kanbanViewSections = [];
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        // if (changes.settingsObj && changes.settingsObj.currentValue) {
        //     const tempValue = changes.settingsObj.currentValue;
        //     if (Object.keys(tempValue).length > 0){
        //         this.processSettingsPopup();
        //     }
        // }

        if(changes?.disabledLabelNames && changes?.disabledLabelNames?.currentValue){
            this.disabledLabelNames =  changes?.disabledLabelNames?.currentValue;
        }

        if (changes.moduleName && changes.moduleName.currentValue) {
            this.moduleName = changes.moduleName.currentValue;
            if (changes.moduleName.currentValue == AccountModuleName){
                this.getDefaultViewForAccount();
            }
            else if (changes.moduleName.currentValue == LeadModuleName){
                this.getDefaultViewForLead();
            }
        }
        if (changes.displayColumnSettings && changes.displayColumnSettings.currentValue == true) {
            this.processSettingsPopup();
            this.app.configuredUserBSubject.subscribe(
                resp => {
                    this.isUserSignedIn = resp;
                }

            )
        }
    }

    setDefaultDisabledColumns(){
        this.defaultDisabledColumns = [];
        switch(this.moduleName){
            case 'Activity':
                this.defaultDisabledColumns = ['comment'];
                break;
            case 'Invoice':
                this.defaultDisabledColumns = ['itemNo'];
                break;
            default:
                break;
        }
    }

    getDefaultViewForAccount(): void {
        this.availableDefaultView = [
            {
                id: 1,
                name: 'List View'
            }
        ];
        this.moduleId = AccountModuleId;
    }

    getDefaultViewForLead(): void {
        this.availableDefaultView = [
            {
                id: 1,
                name: 'List View'
            },
            {
                id: 2,
                name: 'Kanban View'
            }
        ];
        this.moduleId = LeadModuleId;
    }

    processSettingsPopup(): void {
        this.listSearchInput = '';
        this.detailListSearchInput = '';
        this.setDefaultDisabledColumns();
        this.cdr.detectChanges();

        if(this.settingsObj){
            [this.totalAmtForList, this.totalAmtForDetails, this.totalAmtForKanban] = [0, 0, 0];
            if (this.selectedView == 'list') {
                this.tab = 'tab3';
                this.showDiv = {
                    stepsbar: false,
                    views: false,
                    collists: true,
                    config: false,
                    details: false,
                    kanban: false
                }
            } else if (this.selectedView == 'split') {
                this.tab = 'tab4';
                this.showDiv = {
                    stepsbar: false,
                    views: false,
                    collists: false,
                    config: false,
                    details: true,
                    kanban: false
                }
            } else if (this.selectedView == 'kanban') {
                this.tab = 'tab5';
                this.showDiv = {
                    stepsbar: false,
                    views: false,
                    collists: false,
                    config: false,
                    details: false,
                    kanban: true
                }
            }

            this.tempColumnSettings = JSON.parse(JSON.stringify(this.settingsObj));
            this.tempDisplayStepBar = this.tempColumnSettings?.displayStepBar;
            this.tempDisplayStepBarVM = this.tempColumnSettings?.displayStepBar;
            if (this.tempColumnSettings?.defaultViewType == 1){
                this.tempView = {id: 1, name: 'List View'}
                this.tempViewVM = {id: 1, name: 'List View'}
            }
            else if (this.tempColumnSettings?.defaultViewType == 2){
                this.tempView = {id: 2, name: 'Kanban View'}
                this.tempViewVM = {id: 2, name: 'Kanban View'}
            }
            this.tempCols = this.tempColumnSettings?.listViewSections||[];
            this.tempDetailBlocks = this.tempColumnSettings?.detailsViewSections||[];
            this.tempKanbanDetailCols = this.tempColumnSettings?.kanbanViewSections||[];
            this.tempCols.forEach((col, index)=> {col['isToogle'] = (index > 0)});
            this.tempDetailBlocks.forEach((col, index)=> {col['isToogle'] = (index > 0)});
            this.tempColsVM = JSON.parse(JSON.stringify(this.tempColumnSettings?.listViewSections||'[]'));
            this.tempDetailBlocksVM = JSON.parse(JSON.stringify(this.tempColumnSettings?.detailsViewSections||'[]'));
            this.tempKanbanDetailColsVM = JSON.parse(JSON.stringify(this.tempColumnSettings?.kanbanViewSections||'[]'));

            for (let section of this.tempCols) {

                for (let col of section?.fields) {
                    if (col?.childFields.length > 0) {
                        col.showChildren = col.childFields.find(x => x.enabled);
                        for (let childCol of col?.childFields) {
                            if (childCol?.enabled) { this.totalAmtForList++; }
                        }
                    } else {
                        if (col?.enabled && !(this.mergeAccountSequenceNumber && this.moduleId==AccountModuleId && col.columnName=='sequenceNumber')) { this.totalAmtForList++; }
                    }
                }
            }
            this.maxCheckedFieldForList = this.totalAmtForList >= this.maxColumn;

            for (let section of this.tempDetailBlocks) {

                for (let col of section?.fields) {
                    if (col?.childFields.length > 0) {
                        col.showChildren = col.childFields.find(x => x.enabled);
                        for (let childCol of col?.childFields) {
                            if (childCol?.enabled) { this.totalAmtForDetails++; }
                        }
                    } else {
                        if (col?.enabled) { this.totalAmtForDetails++; }
                    }
                }
            }
            this.maxCheckedFieldForDetails = this.totalAmtForDetails >= this.maxColumn;

            if (this.tempKanbanDetailCols?.length > 0){
                for (let section of this.tempKanbanDetailCols) {

                    for (let col of section?.fields) {
                        if (col?.childFields.length > 0) {
                            col.showChildren = col.childFields.find(x => x.enabled);
                            for (let childCol of col?.childFields) {
                                if (childCol?.enabled) { this.totalAmtForKanban++; }
                            }
                        } else {
                            if (col?.enabled) { this.totalAmtForKanban++; }
                        }
                    }
                }
                this.maxCheckedFieldForKanban = this.totalAmtForKanban >= 6;
            }

        }

    }

    onClickSideMenu(serial: number): void {
        /**
         * Here the default cause is not used because
         * we won't get any unexpected input other than
         * mentioned cases
         */
        switch (serial){
            case 1:
                this.tab = 'tab1';
                break;
            case 2:
                this.tab = 'tab2';
                break;
            case 3:
                this.tab = 'tab3';
                break;
            case 4:
                this.tab = 'tab4';
                break;
            case 5:
                this.tab = 'tab5';
                break;
            case 6:
                this.tab = 'tab6';
                break;
        }
    }

    toggleSection(section): void{
        section['isToogle'] = !section?.isToogle;
        // setTimeout(()=>{
        //     if(!this.startDrag){
        //         this.showContent = true;
        //     }
        // },110);
    }

    showChild(col: any): void {
        col.showChildrens = col.showChildrens != undefined ? !col.showChildrens : true;
    }

    dropListSection(event: CdkDragDrop<string[]>, sectionViewType: string) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        if (sectionViewType == 'listViewSection'){
            let allSections: any[] = [];
            allSections = event.container?.data;
            let updatedSections: any[] = [];
            updatedSections = allSections.map((obj, index) => {
                return {
                    name: obj?.name,
                    id: obj?.id,
                    displayOrder: index
                }
            });
            this.updateColumnSettingsData.listViewSections = [];
            updatedSections.forEach((element) => {
                this.updateListViewSection(element);
            });

        }
        else if (sectionViewType == 'detailsViewSection'){
            let allSections: any[] = [];
            allSections = event.container?.data;
            let updatedSections: any[] = [];
            updatedSections = allSections.map((obj, index) => {
                return {
                    name: obj?.name,
                    id: obj?.id,
                    displayOrder: index
                }
            });
            this.updateColumnSettingsData.detailsViewSections = [];
            updatedSections.forEach((element) => {
                this.updateDetailsViewSection(element);
            });
        }
        else if (sectionViewType == 'kanbanViewSection'){
            let allSections: any[] = [];
            allSections = event.container?.data;
            let updatedSections: any[] = [];
            updatedSections = allSections.map((obj, index) => {
                return {
                    name: obj?.name,
                    id: obj?.id,
                    displayOrder: index
                }
            });
            this.updateColumnSettingsData.kanbanViewSections = [];
            updatedSections.forEach((element) => {
                this.updateKanbanViewSection(element);
            });
        }
    }

    updateListViewSection(sections: any): void{
        let selectedField: any;
        let storedField: any;
        let foundIndex: number;

        selectedField = this.tempCols.find(
            (x) => x.name == sections?.name
        );
        selectedField.displayOrder = sections?.displayOrder;
        storedField = this.tempColsVM.find(
            (x) => x.name == sections?.name
        );
        foundIndex = this.updateColumnSettingsData?.listViewSections.findIndex(
            (x) => x?.id == sections?.id
        );
        this.tempColsVM2 = [];
        this.tempColsVM2 = JSON.parse(JSON.stringify(this.tempCols));

        if (selectedField.displayOrder !== storedField.displayOrder) {
            let fieldData: UpdateSections = {
                id: sections?.id,
                displayOrder: sections?.displayOrder,
            };

            if (foundIndex === -1) {
                this.updateColumnSettingsData.listViewSections.push(fieldData);
            } else {
                this.updateColumnSettingsData.listViewSections[foundIndex] = fieldData;
            }
        } else {
            if (foundIndex > -1) {
                this.updateColumnSettingsData.listViewSections.splice(foundIndex, 1);
            }
        }
    }

    updateKanbanViewSection(sections: any): void{
        let selectedField: any;
        let storedField: any;
        let foundIndex: number;

        selectedField = this.tempKanbanDetailCols.find(
            (x) => x.name == sections?.name
        );
        selectedField.displayOrder = sections?.displayOrder;
        storedField = this.tempKanbanDetailColsVM.find(
            (x) => x.name == sections?.name
        );
        foundIndex = this.updateColumnSettingsData?.kanbanViewSections.findIndex(
            (x) => x?.id == sections?.id
        );
        this.tempKanbanDetailColsVM2 = [];
        this.tempKanbanDetailColsVM2 = JSON.parse(JSON.stringify(this.tempKanbanDetailCols));

        if (selectedField.displayOrder !== storedField.displayOrder) {
            let fieldData: UpdateSections = {
                id: sections?.id,
                displayOrder: sections?.displayOrder,
            };

            if (foundIndex === -1) {
                this.updateColumnSettingsData.kanbanViewSections.push(fieldData);
            } else {
                this.updateColumnSettingsData.kanbanViewSections[foundIndex] = fieldData;
            }
        } else {
            if (foundIndex > -1) {
                this.updateColumnSettingsData.kanbanViewSections.splice(foundIndex, 1);
            }
        }
    }

    updateDetailsViewSection(sections: any): void{
        let selectedField: any;
        let storedField: any;
        let foundIndex: number;

        selectedField = this.tempDetailBlocks.find(
            (x) => x.name == sections?.name
        );
        selectedField.displayOrder = sections?.displayOrder;
        storedField = this.tempDetailBlocksVM.find(
            (x) => x.name == sections?.name
        );
        foundIndex = this.updateColumnSettingsData?.detailsViewSections.findIndex(
            (x) => x?.id == sections?.id
        );
        this.tempDetailBlocksVM2 = [];
        this.tempDetailBlocksVM2 = JSON.parse(JSON.stringify(this.tempDetailBlocks));

        if (selectedField.displayOrder !== storedField.displayOrder) {
            let fieldData: UpdateSections = {
                id: sections?.id,
                displayOrder: sections?.displayOrder,
            };

            if (foundIndex === -1) {
                this.updateColumnSettingsData.detailsViewSections.push(fieldData);
            } else {
                this.updateColumnSettingsData.detailsViewSections[foundIndex] = fieldData;
            }
        } else {
            if (foundIndex > -1) {
                this.updateColumnSettingsData.detailsViewSections.splice(foundIndex, 1);
            }
        }

    }

    dropCol(event: CdkDragDrop<string[]>, viewType: string, sectionIndex: number) {
        // if (event.currentIndex > 1)
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

        // this.updateColumnSettingsData.moduleId = this.moduleId;
        // this.updateColumnSettingsData.channelId = this.channelId;
        // this.updateColumnSettingsData.displayStepBar = this.tempDisplayStepBar;
        // this.updateColumnSettingsData.defaultViewType = this.tempView?.id;

        if (viewType == 'listView'){

            const newObj = ParseHelper.DeepCopy(this.tempCols[sectionIndex].fields[event.currentIndex]);

            if(event.previousIndex>event.currentIndex){
                for(let i=event.currentIndex; i<event.previousIndex; i++){
                    const nextI = i+1;
                    const nextObj = this.tempCols[sectionIndex].fields[nextI];
                    const nObj = this.tempCols[sectionIndex].fields[i];
                    nObj.displayOrder = nextObj.displayOrder;
                    this.updateListViewSectionFields(sectionIndex, nObj, 'parent');
                }

                const previousObj = this.tempCols[sectionIndex].fields[event.previousIndex];
                const newDisplayOrder: number = newObj.displayOrder;
                previousObj.displayOrder = newDisplayOrder;
                this.updateListViewSectionFields(sectionIndex, previousObj, 'parent');

            }else{
                for(let i=event.currentIndex; i>event.previousIndex; i--){
                    const prevI = i-1;
                    const prevObj = this.tempCols[sectionIndex].fields[prevI];
                    const nObj = this.tempCols[sectionIndex].fields[i];
                    nObj.displayOrder = prevObj.displayOrder;
                    this.updateListViewSectionFields(sectionIndex, nObj, 'parent');
                }

                const previousObj = this.tempCols[sectionIndex].fields[event.previousIndex];
                const newDisplayOrder: number = newObj.displayOrder;
                previousObj.displayOrder = newDisplayOrder;
                this.updateListViewSectionFields(sectionIndex, previousObj, 'parent');
            }

        }
        else if (viewType == 'detailsView'){
            const newObj = ParseHelper.DeepCopy(this.tempDetailBlocks[sectionIndex].fields[event.currentIndex]);

            if(event.previousIndex>event.currentIndex){
                for(let i=event.currentIndex; i<event.previousIndex; i++){
                    const nextI = i+1;
                    const nextObj = this.tempDetailBlocks[sectionIndex].fields[nextI];
                    const nObj = this.tempDetailBlocks[sectionIndex].fields[i];
                    nObj.displayOrder = nextObj.displayOrder;
                    this.updateDetailsViewSectionFields(sectionIndex, nObj, 'parent');
                }

                const previousObj = this.tempDetailBlocks[sectionIndex].fields[event.previousIndex];
                const newDisplayOrder: number = newObj.displayOrder;
                previousObj.displayOrder = newDisplayOrder;
                this.updateDetailsViewSectionFields(sectionIndex, previousObj, 'parent');

            }else{
                for(let i=event.currentIndex; i>event.previousIndex; i--){
                    const prevI = i-1;
                    const prevObj = this.tempDetailBlocks[sectionIndex].fields[prevI];
                    const nObj = this.tempDetailBlocks[sectionIndex].fields[i];
                    nObj.displayOrder = prevObj.displayOrder;
                    this.updateDetailsViewSectionFields(sectionIndex, nObj, 'parent');
                }

                const previousObj = this.tempDetailBlocks[sectionIndex].fields[event.previousIndex];
                const newDisplayOrder: number = newObj.displayOrder;
                previousObj.displayOrder = newDisplayOrder;
                this.updateDetailsViewSectionFields(sectionIndex, previousObj, 'parent');
            }
        }
        else if (viewType == 'kanbanView') {
            const newObj = ParseHelper.DeepCopy(this.tempKanbanDetailCols[sectionIndex].fields[event.currentIndex]);

            if(event.previousIndex>event.currentIndex){
                for(let i=event.currentIndex; i<event.previousIndex; i++){
                    const nextI = i+1;
                    const nextObj = this.tempKanbanDetailCols[sectionIndex].fields[nextI];
                    const nObj = this.tempKanbanDetailCols[sectionIndex].fields[i];
                    nObj.displayOrder = nextObj.displayOrder;
                    this.updateKanbanViewSectionFields(sectionIndex, nObj, 'parent');
                }

                const previousObj = this.tempKanbanDetailCols[sectionIndex].fields[event.previousIndex];
                const newDisplayOrder: number = newObj.displayOrder;
                previousObj.displayOrder = newDisplayOrder;
                this.updateKanbanViewSectionFields(sectionIndex, previousObj, 'parent');

            }else{
                for(let i=event.currentIndex; i>event.previousIndex; i--){
                    const prevI = i-1;
                    const prevObj = this.tempKanbanDetailCols[sectionIndex].fields[prevI];
                    const nObj = this.tempKanbanDetailCols[sectionIndex].fields[i];
                    nObj.displayOrder = prevObj.displayOrder;
                    this.updateKanbanViewSectionFields(sectionIndex, nObj, 'parent');
                }

                const previousObj = this.tempKanbanDetailCols[sectionIndex].fields[event.previousIndex];
                const newDisplayOrder: number = newObj.displayOrder;
                previousObj.displayOrder = newDisplayOrder;
                this.updateKanbanViewSectionFields(sectionIndex, previousObj, 'parent');
            }
        }
    }

    cdkDragStarted(event: CdkDragStart){
        this.startDrag = true;
        this.showContent = false;
    }

    cdkDragReleased(){
        this.startDrag = false;
        this.showContent = true;
    }

    resetSettings(): void {
        this.confirmationService.confirm({
            message: `Do you want to reset ${this.moduleName} settings to default?`,
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('resetColumnSettings');
                this.sharedColumnSettingService.resetColumnSettings(this.moduleId, this.channelId)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(
                        {
                            next: (response) => {
                                if (response){
                                    this.displayColumnSettings = false;
                                    this.appMainService.isHideSpinner('resetColumnSettings');
                                    this.messageService.add({
                                        severity: 'success',
                                        summary: 'Success',
                                        detail: 'Column settings reset successfully...'
                                      });
                                    this.savedColumnSettings.emit();
                                }
                            },
                            error: (error) => {
                                this.displayColumnSettings = false;
                                this.appMainService.isHideSpinner('resetColumnSettings');
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Error',
                                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings reset not updated, please try again...'
                                });
                            },
                            complete: () => {
                            }
                        }
                    )
            },
            reject: () => {
            }
        });
    }

    checkUncheckField(isChecked: boolean, obj: any, viewType: string, sectionIndex: number, source: string, fieldIndexForChild?: number, parentObj: any = null): void {
        if (isChecked){
            if (viewType == 'listView'){
                if (this.totalAmtForList <= this.maxColumn){
                    this.totalAmtForList++;
                }
            }
            else if (viewType == 'detailsView'){
                if (this.totalAmtForDetails <= this.maxColumn){
                    this.totalAmtForDetails++;
                }
            }
            else if (viewType == 'kanbanView'){
                if (this.totalAmtForKanban <= 6){
                    this.totalAmtForKanban++;
                }
            }
        }
        else {
            if (viewType == 'listView'){
                this.totalAmtForList--;
            }
            else if (viewType == 'detailsView'){
                this.totalAmtForDetails--;
            }
            else if (viewType == 'kanbanView'){
                this.totalAmtForKanban--;
            }
        }
        this.maxCheckedFieldForList = this.totalAmtForList >=this.maxColumn;
        this.maxCheckedFieldForDetails = this.totalAmtForDetails >=this.maxColumn;
        this.maxCheckedFieldForKanban = this.totalAmtForKanban >= 6;

        if(obj){
            if (viewType == 'listView'){
                this.updateListViewSectionFields(sectionIndex, obj, source, fieldIndexForChild, parentObj);
            }
            else if (viewType == 'detailsView'){
                this.updateDetailsViewSectionFields(sectionIndex, obj, source, fieldIndexForChild, parentObj);
            }
            else if (viewType == 'kanbanView'){
                this.updateKanbanViewSectionFields(sectionIndex, obj, source, fieldIndexForChild, parentObj);
            }

        }


    }

    updateListViewSectionFields(sectionIndex: number, obj: any, source: string, fieldIndexForChild?: number, parentObj: any = null): void {
        let selectedField: any;
        let storedField: any;
        let foundIndex: number;

        if (source == 'parent'){
            selectedField = this.tempCols[sectionIndex].fields.find(
                (x) => x.id == obj.id
            );
            // When user both change the section postion and fields check/uncheck
            if (this.updateColumnSettingsData?.listViewSections?.length > 0){
                storedField = this.tempColsVM2[sectionIndex].fields.find(
                    (x) => x.id == obj.id
                );
            }
            else {
                storedField = this.tempColsVM[sectionIndex].fields.find(
                    (x) => x.id == obj.id
                );
            }
        }
        else if (source == 'child'){

            if(!fieldIndexForChild && parentObj?.id){
                fieldIndexForChild = this.tempCols[sectionIndex].fields.findIndex((x) => x.id == parentObj?.id)
            }

            selectedField = this.tempCols[sectionIndex].fields[fieldIndexForChild].childFields.find(
                (x) => x.id == obj.id
            );
            storedField = this.tempColsVM[sectionIndex].fields[fieldIndexForChild].childFields.find(
                (x) => x.id == obj.id
            );
        }


        foundIndex = this.updateColumnSettingsData?.listViewFields.findIndex(
            (x) => x?.id == obj?.id
        );

        if (selectedField?.enabled !== storedField?.enabled ||
            selectedField?.displayOrder !== storedField?.displayOrder) {
            let fieldData: UpdateFields = {
                id: obj?.id,
                enabled: obj?.enabled,
                displayOrder: obj?.displayOrder,
            };

            if (foundIndex === -1) {
                this.updateColumnSettingsData.listViewFields.push(fieldData);
            } else {
                this.updateColumnSettingsData.listViewFields[foundIndex] = fieldData;
            }
        } else {
            if (foundIndex > -1) {
                this.updateColumnSettingsData.listViewFields.splice(foundIndex, 1);
            }
        }
    }

    updateDetailsViewSectionFields(sectionIndex: number, obj: any, source: string, fieldIndexForChild?: number, parentObj: any = null): void {
        let selectedField: any;
        let storedField: any;
        let foundIndex: number;

        if (source == 'parent'){
            selectedField = this.tempDetailBlocks[sectionIndex].fields.find(
                (x) => x.id == obj.id
            );
            // When user both change the section postion and fields check/uncheck
            if (this.updateColumnSettingsData?.detailsViewSections?.length > 0){
                storedField = this.tempDetailBlocksVM2[sectionIndex].fields.find(
                    (x) => x.id == obj.id
                );
            }
            else {
                storedField = this.tempDetailBlocksVM[sectionIndex].fields.find(
                    (x) => x.id == obj.id
                );
            }

        }
        else if (source == 'child'){

            if(!fieldIndexForChild && parentObj?.id){
                fieldIndexForChild = this.tempCols[sectionIndex].fields.findIndex((x) => x.id == parentObj?.id)
            }

            selectedField = this.tempDetailBlocks[sectionIndex].fields[fieldIndexForChild].childFields.find(
                (x) => x.id == obj.id
            );
            storedField = this.tempDetailBlocksVM[sectionIndex].fields[fieldIndexForChild].childFields.find(
                (x) => x.id == obj.id
            );
        }

        foundIndex = this.updateColumnSettingsData?.detailsViewFields.findIndex(
            (x) => x?.id == obj?.id
        );

        if (selectedField.enabled !== storedField.enabled ||
            selectedField.displayOrder !== storedField.displayOrder) {
            let fieldData: UpdateFields = {
                id: obj?.id,
                enabled: obj?.enabled,
                displayOrder: obj?.displayOrder,
            };

            if (foundIndex === -1) {
                this.updateColumnSettingsData.detailsViewFields.push(fieldData);
            } else {
                this.updateColumnSettingsData.detailsViewFields[foundIndex] = fieldData;
            }
        } else {
            if (foundIndex > -1) {
                this.updateColumnSettingsData.detailsViewFields.splice(foundIndex, 1);
            }
        }
    }

    updateKanbanViewSectionFields(sectionIndex: number, obj: any, source: string, fieldIndexForChild?: number, parentObj: any = null): void {
        let selectedField: any;
        let storedField: any;
        let foundIndex: number;

        if (source == 'parent'){
            selectedField = this.tempKanbanDetailCols[sectionIndex].fields.find(
                (x) => x.id == obj.id
            );
            // When user both change the section postion and fields check/uncheck
            if (this.updateColumnSettingsData?.kanbanViewSections?.length > 0){
                storedField = this.tempKanbanDetailColsVM2[sectionIndex].fields.find(
                    (x) => x.id == obj.id
                );
            }
            else {
                storedField = this.tempKanbanDetailColsVM[sectionIndex].fields.find(
                    (x) => x.id == obj.id
                );
            }

        }
        else if (source == 'child'){

            if(!fieldIndexForChild && parentObj?.id){
                fieldIndexForChild = this.tempCols[sectionIndex].fields.findIndex((x) => x.id == parentObj?.id)
            }

            selectedField = this.tempKanbanDetailCols[sectionIndex].fields[fieldIndexForChild].childFields.find(
                (x) => x.id == obj.id
            );
            storedField = this.tempKanbanDetailColsVM[sectionIndex].fields[fieldIndexForChild].childFields.find(
                (x) => x.id == obj.id
            );
        }

        foundIndex = this.updateColumnSettingsData?.kanbanViewFields.findIndex(
            (x) => x?.id == obj?.id
        );

        if (selectedField.enabled !== storedField.enabled) {
            let fieldData: UpdateFields = {
                id: obj?.id,
                enabled: obj?.enabled,
                displayOrder: obj?.displayOrder,
            };

            if (foundIndex === -1) {
                this.updateColumnSettingsData.kanbanViewFields.push(fieldData);
            } else {
                this.updateColumnSettingsData.kanbanViewFields[foundIndex] = fieldData;
            }
        } else {
            if (foundIndex > -1) {
                this.updateColumnSettingsData.kanbanViewFields.splice(foundIndex, 1);
            }
        }
    }

    saveColumnSettings(): void {

            this.updateColumnSettingsData.moduleId = this.moduleId;
            this.updateColumnSettingsData.channelId = this.channelId;
            this.updateColumnSettingsData.displayStepBar = this.tempDisplayStepBar;
            this.updateColumnSettingsData.defaultViewType = this.tempView?.id;

            let updatedColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(this.settingsObj);

            updatedColumnSettings.listViewSections = ParseHelper.DeepCopy(this.tempCols);

            this.displayColumnSettings = false;
            this.detectStepBarOrDefaultViewChange = false;
            this.isSelectAllSectionField = false;
            this.savedColumnSettings.emit({updatedColumnSettings:updatedColumnSettings,updateColumnSettingsData:this.updateColumnSettingsData});
    }

    detectDisplayStepBarChange(event: any): void {
        if (event){
            const selectedStepBar: boolean = event?.checked;
            if (selectedStepBar != this.tempDisplayStepBarVM){
                this.detectStepBarOrDefaultViewChange = true;
            }
            else {
                this.detectStepBarOrDefaultViewChange = false;
            }
        }
    }

    detectDefaultViewChange(event: any): void {
        if (event?.value){
            const selectedId : number = event?.value?.id;
            if (selectedId != this.tempViewVM.id){
                this.detectStepBarOrDefaultViewChange = true;
            }
            else {
                this.detectStepBarOrDefaultViewChange = false;
            }
        }
    }

    clearValues(): void {
        [
            this.updateColumnSettingsData.listViewFields,
            this.updateColumnSettingsData.detailsViewFields,
            this.updateColumnSettingsData.kanbanViewFields,
            this.updateColumnSettingsData.listViewSections,
            this.updateColumnSettingsData.detailsViewSections,
            this.updateColumnSettingsData.kanbanViewSections
        ] = [[], [], [], [], [], []];
        this.detectStepBarOrDefaultViewChange = false;
        this.isSelectAllSectionField = false;
    }

    cancelSettings(): void {
        this.cancelColumnSettings.emit();
        this.clearValues();
    }

    enableAllSectionFields($event: any, sections: any[], viewType: string) {
            const checked = !!$event?.checked;
            this.isSelectAllSectionField = checked;
            if(sections?.length>0){
                for (let s = 0; s < sections.length; s++) {
                    if (checked && this.isMaxFieldsSelected(viewType)) break;
                    const section = sections[s];
                    this.enableSectionFields({checked: checked}, section, viewType, s);
                }
            }
        }
    
    
        enableSectionFields($event: any, section: any, viewType: string, sectionIndex: number) {
            const checked = !!$event?.checked;
            for (let f = 0; f < section.fields.length; f++) {
                if (checked && this.isMaxFieldsSelected(viewType)) break;
                const field = section.fields[f];
                if (field?.childFields?.length) {
                    for (let i = 0; i < field.childFields.length; i++) {
                        if (checked && this.isMaxFieldsSelected(viewType)) break;
                        const childField = field.childFields[i];
                        const isChildDisabled = ((childField.isRequired && childField.enabled) ||
                            (this.disabledLabelNames.includes(childField.columnName) && childField.enabled)
                        );
                        const enabled = isChildDisabled ? true : checked;
                        if (childField.enabled != enabled) {
                            childField.enabled = enabled;
                            this.checkUncheckField(enabled, childField, viewType, sectionIndex, 'child', f);
                        }
                    }
                } else {
                    const isDisabled = ((field?.columnName == 'businessName') || (field?.columnName == 'taskId') ||
                        (field.enabled && field?.columnName == 'sequenceNumber' && this.mergeAccountSequenceNumber && this.moduleId == AccountModuleId) ||
                        (this.moduleId == OpportunityModuleId && field?.columnName == 'name') ||
                        (this.moduleId == CaseModuleId && field?.columnName == 'associationName' && field.enabled) ||
                        (this.disabledLabelNames.includes(field.columnName) && field.enabled)
                    );
                    const enabled = isDisabled ? true : checked;
                    if (field.enabled != enabled) {
                        field.enabled = enabled;
                        this.checkUncheckField(checked, field, viewType, sectionIndex, 'parent');
                    }
                }
            }
        }
    
        isMaxFieldsSelected(viewType: string){
            switch(viewType){
                case 'listView':
                    return (this.totalAmtForList >= this.maxColumn);
                case 'detailsView':
                    return (this.totalAmtForDetails >= this.maxColumn);
                case 'kanbanView':
                    return (this.totalAmtForKanban >= 6);
            }
    
            return true;
        }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}
